import { Component, OnInit, Input, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import * as moment from 'moment';
import { FormControl } from '@angular/forms';
import { SaleService } from 'src/app/services/partner/sale.service';
import { MainService } from 'src/app/services/delavci/main.service';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { Sale } from 'src/app/models/Sale';
import { Router } from '@angular/router';
import { SaleParameters } from 'src/app/models/SaleParameters';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { SaleAllParameters } from 'src/app/models/SaleAllParameters';
import { Subscription, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SaleOrder } from 'src/app/models/SaleOrder';
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'DD.MM.YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'DD.MM.YYYY',
  },
};
@Component({
  selector: 'app-sale-skladisce',
  templateUrl: './sale-skladisce.component.html',
  styleUrls: ['./sale-skladisce.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class SaleSkladisceComponent implements OnInit, OnChanges, OnDestroy {

  //@Input() saleType;
  public saleType;
  public dataList: Array<Sale>;
  public panelOpenState;
  public countryList: Array<string> = [];
  public dateList: Array<string> = [];
  public displayedColumns: string[] = ['title', 'saleVal', 'calculate'];
  public dataSource: Array<Sale>;
  public tableByCountries: Array<Array<Array<Sale>>> = [[]];
  public tableByDates = [];
  public isEmptyInsideList = [];
  public counter;
  public sumArray: Array<Array<string>>;
  public spinner = true;
  public dateSumArray: Array<Array<number>> = [[]];
  public shouldBeExpanded;
  public showCountry;
  public showNaPlan;
  public showCmp;
  public saleFilter;
  public REPAPNL1: any;
  public reportId: SaleParameters;
  public showEURValues: number;
  public showTaxValues: number;
  public workerWarehouseTypes: SaleParameters[];
  public workerWarehouses;
  public workerWarehouseCountries: SaleParameters[];
  public order: SaleOrder;
  public sort: SaleOrder;
  public fetchLS: any;
  public groupType: SaleParameters;
  public samodejniDatum: any;
  public sumDatesVar = 0;
  public sumDatesVarCmp = 0;
  public sumDatesVarPlan = 0;
  public outCalcCmp = 0;
  public outCalcPlan = 0;
  public showGraphBool = false;
  public showSettings = false;
  public firstInit = true;
  public refreshTimerSub;
  public chbx_hitroOsvezevanje: boolean;
  constructor(private saleService: SaleService, private mainService: MainService, private router: Router, private _snackBar: MatSnackBar) { }

  ngOnInit() {
    this.parametersInit();
    this.saleType = this.saleService.currentSaleTypeValue;

    this.mainService.prodajaSettingsBool.subscribe(data => {
      this.showSettings = data;
      if(this.showGraphBool) {
        this.showGraphBool = false;
      }
    });
    if(!this.saleService.currentSaleFilterValue){
      this.saleService.changeSaleFilter('SALEVALUE');
    }

    this.saleService.currentSaleFilter.subscribe( data => {
      this.saleFilter = data;
      if (this.router.url === '/prodaja/izbira/skladisca') {
        if (this.saleFilter === 'MARGINPERCENT' || this.saleFilter === 'SALEVALUE' || this.saleFilter === 'SALEVALUEWT') {
        } else {
          this.saleService.changeSaleFilter('SALEVALUE');
        }
      }
      if(!this.firstInit) {
        this.sumAllDates();
      }

    }, error => {
      console.log(error);
    });
    this.saleService.currentSaleParameters.subscribe(data => {
      this.parametersInit();
      if(!this.firstInit){
        this.refreshTimerSub.unsubscribe();
        if(this.chbx_hitroOsvezevanje) {
          this.refreshTimerSub = timer(0, 300000).subscribe( () => this.callSaleWS());
        } else {
          this.refreshTimerSub = timer(0, 3600000).subscribe( () => this.callSaleWS());
        }
      }
    });
    if(this.chbx_hitroOsvezevanje) {
      this.refreshTimerSub = timer(0, 300000).subscribe( () => this.callSaleWS());
    } else {
      this.refreshTimerSub = timer(0, 3600000).subscribe( () => this.callSaleWS());
    }
    this.mainService.changeHref(this.router.url);
  }
  ngOnChanges(changes: SimpleChanges) {
    if(changes.saleType.currentValue) {
      this.dateList = [];
      this.countryList = [];
      this.dateSumArray = [[]];
      this.sumArray = [[]];
      this.callSaleWS();
    }
}

ngOnDestroy() {
  this.refreshTimerSub.unsubscribe();
}

parametersInit() {
  this.REPAPNL1 = this.saleService.currentSaleParametersValue.timeCompare;
  this.reportId = this.saleService.currentSaleParametersValue.reportsList;
  this.showEURValues = this.saleService.currentSaleParametersValue.chxb_EUR ? 1 : 0;
  this.chbx_hitroOsvezevanje = this.saleService.currentSaleParametersValue.chbx_hitroOsvezevanje;
  this.workerWarehouseTypes = this.saleService.currentSaleParametersValue.typesList;
  this.workerWarehouses = this.saleService.currentSaleParametersValue.warehousesList;
  this.workerWarehouseCountries = this.saleService.currentSaleParametersValue.countriesList;
  this.order = this.saleService.currentSaleParametersValue.orderList;
  this.sort = this.saleService.currentSaleParametersValue.sortList;
  this.fetchLS = this.saleService.currentSaleParametersValue.fetch;
  this.groupType = this.saleService.currentSaleParametersValue.groupType;
  this.samodejniDatum = this.saleService.currentSaleParametersValue.chxb_samodejniDatum;
  this.shouldBeExpanded = this.saleService.currentSaleParametersValue.chxb_razprto;
  this.showCountry = this.saleService.currentSaleParametersValue.chxb_prikaziDrzave;
  this.showNaPlan = this.saleService.currentSaleParametersValue.chxb_prikaziProcentNaPlan;
  this.showCmp = this.saleService.currentSaleParametersValue.chxb_prikaziProcent;
}

  callSaleWS() {
    if(this.firstInit) {
      this.firstInit = false;
    }
    let dateFromLS;
    let dateToLS;
    this.spinner = true;
    if(this.saleService.currentSaleParametersValue) {

      if(this.saleType === 'SALE_DATE_PART_01') {
        this.showNaPlan = this.saleService.currentSaleParametersValue.chxb_prikaziProcentNaPlan;
      } else {
        this.showNaPlan = false;
      }
      this.showCmp = this.saleService.currentSaleParametersValue.chxb_prikaziProcent;
      if (this.samodejniDatum) {
        dateFromLS = (moment().startOf('month')).format("DD.MM.YYYY");
        dateToLS = (moment()).format("DD.MM.YYYY");
      } else {
        dateFromLS = this.saleService.currentSaleParametersValue.dateFrom;
        dateToLS = this.saleService.currentSaleParametersValue.dateTo;
      }
      this.saleService.sale(this.mainService.currentUserValue.sessionUser, dateFromLS,
       dateToLS, this.REPAPNL1, this.reportId, 1, this.showEURValues, /* showTaxValues,*/ this.workerWarehouseTypes,
       this.workerWarehouseCountries, this.order, this.sort, this.fetchLS, this.saleType, this.groupType, this.workerWarehouses).subscribe( data => {
          this.dataList = data.data.sale;
          if(this.saleType != 'SALE_HOUR_01') {
            this.dateFormatter();
          }
          this.extractCountries();
          this.extractDates();
          this.sortByDate();
          this.spinner = false;
          this.sumAllDates();
          this.createListDatesValues();


      }, error => {
        console.log(error);
        this.spinner = false;
        this.openSnackBar(error.message);
      });
    } else {
      dateFromLS = moment().startOf('month').format('DD.MM.YYYY');
      dateToLS = moment().format('DD.MM.YYYY');
      this.saleService.saleNoParams(this.mainService.currentUserValue.sessionUser, dateFromLS,
        dateToLS, 1, null, /* null,*/ this.saleType).subscribe( data => {
          if(this.saleType === 'SALE_HOUR_01') {
            this.dataList = data.data.sale;
            this.extractCountries();
            this.extractDates();
            this.sortByDate();
            this.spinner = false;
          } else {
            this.dataList = data.data.sale;
            this.dateFormatter();
            this.extractCountries();
            this.extractDates();
            this.sortByDate();
            this.spinner = false;
          }

    }, error => {
      console.log(error);
      this.spinner = false;
      this.openSnackBar(error.message);
    });
    }

  }

  sortByDate() {
    for(let i = 0; i < this.dateList.length; i++) {
      this.tableByCountries[i] = [];
      for(let j = 0; j < this.countryList.length; j++) {
        this.tableByCountries[i][j] = [];
        for(let k = 0; k < this.dataList.length; k++) {
          if(this.dateList[i] === this.dataList[k].date && this.countryList[j] === this.dataList[k].country) {
            this.tableByCountries[i][j].push(this.dataList[k]);
          }
        }
      }
    }
  }

  //podatki za graf (Line chart letos lani)
  createListDatesValues() {
    for(let i = 0; i < this.dateList.length; i++) {
      let sumVal = 0;
      let sumCmp = 0;
      this.tableByDates[i] = [];
      for(let j = 0; j < this.dataList.length; j++) {
        if(this.dateList[i] === this.dataList[j].date) {
          sumVal += this.dataList[j].saleVal;
          sumCmp += this.dataList[j].saleValCmp;
        }
      }
      //na prvem mestu so letosnje na drugem pa lanske
      this.tableByDates[i].push((this.roundingToolNoDecimal(sumVal)));
      this.tableByDates[i].push((this.roundingToolNoDecimal(sumCmp)));
    }
  }
  nullPointer(dateIndex, countryIndex) {

    if (this.tableByCountries[dateIndex][countryIndex].length > 0) {
      return true;
    } else {
      return false;
    }


  }

  dateFormatter() {
    for(let i = 0; i < this.dataList.length; i ++) {
      this.dataList[i].date = moment(this.dataList[i].date).format("DD.MM.YYYY");
    }
  }

  extractCountries() {
    for(let i = 0; i < this.dataList.length; i ++) {
      if (!this.countryList.includes(this.dataList[i].country.toString())) {
        this.countryList.push(this.dataList[i].country);
      }
    }
  }

  extractDates() {
    for(let i = 0; i < this.dataList.length; i ++) {

      if (!this.dateList.includes(this.dataList[i].date.toString())) {
        this.dateList.push(this.dataList[i].date);
      }
    }
  }

  calculateSaleVal(element: Sale) {
    if(this.saleFilter === 'SALEVALUE'){
      if (element.saleValCmp == 0) {
        return 0;
      } else {
        return (element.saleVal / element.saleValCmp) * 100;
      }
    } else if (this.saleFilter === 'MARGINPERCENT') {
      if (element.marginPrcCmp == 0) {
        return 0;
      } else {
        return (element.marginPrc / element.marginPrcCmp) * 100;
      }
    } else if (this.saleFilter === 'SALEVALUEWT') {
      if (element.saleValWTCmp == 0) {
        return 0;
      } else {
        return (element.saleValWT / element.saleValWTCmp) * 100;
      }
    } else if (this.saleFilter === 'QUANTITY') {
      if (element.quantityCmp == 0) {
        return 0;
      } else {
        return (element.quantity / element.quantityCmp) * 100;
      }
    } else if (this.saleFilter === 'DOCUMENTCOUNT') {
      if (element.docCountCmp == 0) {
        return 0;
      } else {
        return (element.docCount / element.docCountCmp) * 100;
      }
    } else if (this.saleFilter === 'ITEMCOUNT') {
      if (element.itemCountCmp == 0) {
        return 0;
      } else {
        return (element.itemCount / element.itemCountCmp) * 100;
      }
    }
  }

  countrySum(dateIndex, countryIndex)  {
    let sum = 0;
    for(let i = 0; i < this.tableByCountries[dateIndex][countryIndex].length; i++){
      if(this.saleFilter === 'SALEVALUE') {
        sum += this.tableByCountries[dateIndex][countryIndex][i].saleVal;
      } else if (this.saleFilter === 'MARGINPERCENT') {
        sum += this.tableByCountries[dateIndex][countryIndex][i].marginPrc;
      } else if (this.saleFilter === 'SALEVALUEWT') {
        sum += this.tableByCountries[dateIndex][countryIndex][i].saleValWT;
      } else if (this.saleFilter === 'QUANTITY') {
        sum += this.tableByCountries[dateIndex][countryIndex][i].quantity;
      } else if (this.saleFilter === 'DOCUMENTCOUNT') {
        sum += this.tableByCountries[dateIndex][countryIndex][i].docCount;
      } else if (this.saleFilter === 'ITEMCOUNT') {
        sum += this.tableByCountries[dateIndex][countryIndex][i].itemCount;
      }
    }
    return sum;
  }

  dateSum(dateIndex) {
    let sum = 0;
    for(let i = 0; i < this.tableByCountries[dateIndex].length; i++){
      for(let j = 0; j < this.tableByCountries[dateIndex][i].length; j++){
        if (this.saleFilter === 'SALEVALUE') {
          sum += this.tableByCountries[dateIndex][i][j].saleVal;
        } else if (this.saleFilter === 'MARGINPERCENT') {
          sum += this.tableByCountries[dateIndex][i][j].marginPrc;
        } else if (this.saleFilter === 'SALEVALUEWT') {
          sum += this.tableByCountries[dateIndex][i][j].saleValWT;
        } else if (this.saleFilter === 'QUANTITY') {
          sum += this.tableByCountries[dateIndex][i][j].quantity;
        } else if (this.saleFilter === 'DOCUMENTCOUNT') {
          sum += this.tableByCountries[dateIndex][i][j].docCount;
        } else if (this.saleFilter === 'ITEMCOUNT') {
          sum += this.tableByCountries[dateIndex][i][j].itemCount;
        }
      }
    }
    return sum;
  }

  dateSumCmp(dateIndex) {
    let sum = 0;
    for(let i = 0; i < this.tableByCountries[dateIndex].length; i++){
      for(let j = 0; j < this.tableByCountries[dateIndex][i].length; j++){
        if(this.saleFilter === 'SALEVALUE') {
          sum += this.tableByCountries[dateIndex][i][j].saleValCmp;
      } else if(this.saleFilter === 'MARGINPERCENT') {
        sum += this.tableByCountries[dateIndex][i][j].marginPrcCmp;
      } else if (this.saleFilter === 'SALEVALUEWT') {
        sum += this.tableByCountries[dateIndex][i][j].saleValWTCmp;
      } else if (this.saleFilter === 'QUANTITY') {
        sum += this.tableByCountries[dateIndex][i][j].quantityCmp;
      } else if (this.saleFilter === 'DOCUMENTCOUNT') {
        sum += this.tableByCountries[dateIndex][i][j].docCountCmp;
      } else if (this.saleFilter === 'ITEMCOUNT') {
        sum += this.tableByCountries[dateIndex][i][j].itemCountCmp;
      }
      }
    }
    return sum;
  }

  countryCmpForColoring(dateIndex, countryIndex) {
    let sumCmp = 0;
    for(let i = 0; i < this.tableByCountries[dateIndex][countryIndex].length; i++){
      if(this.saleFilter === 'SALEVALUE') {
        sumCmp += this.tableByCountries[dateIndex][countryIndex][i].saleValCmp;
      } else if (this.saleFilter === 'MARGINPERCENT'){
        sumCmp += this.tableByCountries[dateIndex][countryIndex][i].marginPrcCmp;
      } else if (this.saleFilter === 'SALEVALUEWT') {
        sumCmp +=  this.tableByCountries[dateIndex][countryIndex][i].saleValWT;
      } else if (this.saleFilter === 'QUANTITY') {
        sumCmp +=  this.tableByCountries[dateIndex][countryIndex][i].quantityCmp;
      } else if (this.saleFilter === 'DOCUMENTCOUNT') {
        sumCmp +=  this.tableByCountries[dateIndex][countryIndex][i].docCountCmp;
      } else if (this.saleFilter === 'ITEMCOUNT') {
        sumCmp +=  this.tableByCountries[dateIndex][countryIndex][i].itemCountCmp;
      }
    }
    return sumCmp;
  }

  countryCalcCmp(dateIndex, countryIndex) {
    let sumSaleVal = this.countrySum(dateIndex, countryIndex);
    let sumCmp = this.countryCmpForColoring(dateIndex, countryIndex);
    if (sumCmp == 0) {
      return 0;
    } else {
      return (sumSaleVal / sumCmp ) * 100;
    }
  }

  dateCalcCmp(dateIndex) {
    let sumSaleVal = this.dateSum(dateIndex);
    let sumCmp = this.dateSumCmp(dateIndex);

    if (sumCmp == 0) {
      return 0;
    } else {
      return (sumSaleVal / sumCmp ) * 100;
    }
  }

  onFilterSubmit() {
    this.spinner = true;
    this.callSaleWS();
  }

  /*roundingTool(num) {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }*/

  showValue(num: Sale) {
    if(this.saleFilter === 'SALEVALUE') {
      return Math.round(num.saleVal);
    } else if(this.saleFilter === 'MARGINPERCENT') {
      return Math.round(num.marginPrc);
    } else if (this.saleFilter === 'SALEVALUEWT') {
      return Math.round(num.saleValWT);
    } else if (this.saleFilter === 'QUANTITY') {
      return Math.round(num.quantity);
    } else if (this.saleFilter === 'DOCUMENTCOUNT') {
      return Math.round(num.docCount);
    } else if (this.saleFilter === 'ITEMCOUNT') {
      return Math.round(num.itemCount);
    }
  }
  roundingToolNoDecimal(num) {
    return Math.round(num);
  }
  addCommas(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }
    return x1 + x2;
}

sumAllDates() {
  this.sumDatesVarCmp = 0;
  this.sumDatesVar = 0;
  this.sumDatesVarPlan = 0;
  for(let k = 0; k < this.tableByCountries.length; k++) {
    for(let i = 0; i < this.tableByCountries[k].length; i++){
      for(let j = 0; j < this.tableByCountries[k][i].length; j++){
        if(this.saleFilter === 'SALEVALUE') {
          this.sumDatesVar += this.tableByCountries[k][i][j].saleVal;
          this.sumDatesVarCmp += this.tableByCountries[k][i][j].saleValCmp;
          this.sumDatesVarPlan += this.tableByCountries[k][i][j].saleValPlan;
        } else if(this.saleFilter === 'MARGINPERCENT') {
          this.sumDatesVar += this.tableByCountries[k][i][j].marginPrc;
          this.sumDatesVarCmp += this.tableByCountries[k][i][j].marginPrcCmp;
          this.sumDatesVarPlan += this.tableByCountries[k][i][j].marginValPlan;
        } else if (this.saleFilter === 'SALEVALUEWT') {
          this.sumDatesVar += this.tableByCountries[k][i][j].saleValWT;
          this.sumDatesVarCmp += this.tableByCountries[k][i][j].saleValWTCmp;
          this.sumDatesVarPlan += this.tableByCountries[k][i][j].saleValWTPlan;
        } else if (this.saleFilter === 'QUANTITY') {
          this.sumDatesVar += this.tableByCountries[k][i][j].quantity;
          this.sumDatesVarCmp += this.tableByCountries[k][i][j].quantityCmp;
        } else if (this.saleFilter === 'DOCUMENTCOUNT') {
          this.sumDatesVar += this.tableByCountries[k][i][j].docCount;
          this.sumDatesVarCmp += this.tableByCountries[k][i][j].docCountCmp;
        } else if (this.saleFilter === 'ITEMCOUNT') {
          this.sumDatesVar += this.tableByCountries[k][i][j].itemCount;
          this.sumDatesVarCmp += this.tableByCountries[k][i][j].itemCountCmp;
        }
      }
    }
  }
  this.allDateCalcCmp();
}

allDateCalcCmp() {
  if (this.sumDatesVarCmp == 0) {
      this.outCalcCmp = 0;
    } else {
      this.outCalcCmp = (this.sumDatesVar / this.sumDatesVarCmp ) * 100;
    }

    if (this.sumDatesVarPlan == 0) {
      this.outCalcPlan = 0;
    } else {
      this.outCalcPlan = (this.sumDatesVar / this.sumDatesVarPlan ) * 100;
    }
}

showGraph() {
  if(this.showGraphBool) {
    this.showGraphBool = false;
  } else {
    this.showGraphBool = true;
  }
}

openSnackBar(message: string) {
  this._snackBar.open(message, '', {
    duration: 2000,
  });
}

  spliceCountry(country: string) {
    if(country.length > 30) {
      return country.substring(0, 30) + '...';
    } else {
      return country;
    }
  }
}
